/**
 * Branding Section Transformers
 * Aggregates all branding-related transformers and provides section-level utilities
 */

import { transformBrandingUrl } from './urlTransformer';
import { transformCustom404 } from './custom404Transformer';

// Re-export individual transformers
export { transformBrandingUrl } from './urlTransformer';
export { transformCustom404 } from './custom404Transformer';

/**
 * Transforms all branding section criteria from WooRank API response
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} - Transformed branding section data with aggregated counts
 */
export const transformBrandingSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};
  const fallbackUrl = apiData?.url || '';

  const url = transformBrandingUrl(criteria?.url, fallbackUrl);
  const custom404 = transformCustom404(criteria?.custom_404);

  const allResults = [url, custom404];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    url,
    custom404,
  };
};

export default transformBrandingSection;


